export function validateGraphConfig(config = {}) {
	let sections = config.graphTemplate?.sections || []
	let nodes = config.graphTemplate?.nodes || []
	if (!config.title || (!Array.isArray(sections) || !sections.length) && (!Array.isArray(nodes) || !nodes.length)) {
		throw new Error("Invalid graph tool configuration")
	}
	for (let section of sections) {
		if (!section.id || !section.title) {
			throw new Error("Invalid graph section configuration")
		}
	}
}

export function validateGraphPayload(enginePayload = {}, config = {}) {
	let graph = enginePayload.graph || null
	if (!graph || !Array.isArray(graph.nodes) || !Array.isArray(graph.edges)) {
		throw new Error("Invalid graph engine payload")
	}
	validateGraphConfig(config || {})
	validateGraphNodeSections(graph.nodes, config || {})
	validateGraphEdgeReferences(graph)
}

export function validateGraphNodeSections(nodes = [], config = {}) {
	let sectionIds = new Set((config.graphTemplate?.sections || []).map(section => section.id))
	for (let node of nodes) {
		if (!node.id || (sectionIds.size && node.data?.sectionId && !sectionIds.has(node.data.sectionId))) {
			throw new Error("Invalid graph node")
		}
	}
}

export function validateGraphEdgeReferences(graph = {}) {
	let nodeIds = new Set((graph.nodes || []).map(node => node.id))
	for (let edge of graph.edges || []) {
		if (!edge.id || !nodeIds.has(edge.sourceId) || (edge.targetId && !nodeIds.has(edge.targetId))) {
			throw new Error("Invalid graph edge")
		}
	}
}

